import { ProjectId } from '../types'

export const top5Projects: ProjectId[] = [
    'blank',
    'iterate',
    'spacemaker',
    'masterdegree',
    'sol-start',
]
